import React from 'react';
import { wrapFunctionalComponent } from 'utils/framework';
import { Text, Box } from 'components/ui';
import { colors } from 'style/config';

const ProductViewsCount = props => {
    const {
        peopleViewing,
        thresholdForViews,
        localization,
        formatViewCount,
        setAnalytics,
        lookBackWindowForViews,
        showSessionAIMsg,
        showSocialProofPDP,
        blackBackground,
        extraMargin,
        unlockWidth = false
    } = props;
    const hasReachedThreshold = peopleViewing && thresholdForViews && peopleViewing >= thresholdForViews;

    if (hasReachedThreshold) {
        setAnalytics(lookBackWindowForViews);
    }

    if ((!showSessionAIMsg && !showSocialProofPDP) || !peopleViewing || !thresholdForViews || !hasReachedThreshold) {
        return null;
    }

    const isChallenger = showSocialProofPDP.challengerOne || showSocialProofPDP.challengerTwo;
    const isTransparentStyle = isChallenger && !blackBackground;
    const popularLabel = showSocialProofPDP.challengerOne ? localization.popular : localization.popularNow;
    const viewsLabel = showSocialProofPDP.challengerOne ? localization.recentViews : localization.peopleViewed;

    return (
        <Box
            marginTop={4}
            backgroundColor={colors.black}
            borderRadius={2}
            paddingLeft={2}
            paddingRight={2}
            width='fit-content'
            {...(!unlockWidth && { maxWidth: '375px' })}
            {...(isTransparentStyle && { marginTop: extraMargin ? '2px' : 0, paddingLeft: 0, backgroundColor: 'unset' })}
        >
            <Text
                is='p'
                lineHeight='24px'
                fontSize='sm'
                color={colors.white}
                {...(isTransparentStyle && { color: colors.black, lineHeight: 1, verticalAlign: 'middle' })}
            >
                <Text paddingRight={1}>🤩</Text>
                <Text {...(showSocialProofPDP.challengerOne && !showSocialProofPDP.challengerTwo && { fontWeight: 'bold' })}>
                    {popularLabel}
                </Text>{' '}
                <strong>{formatViewCount(peopleViewing)}+</strong> {viewsLabel}
            </Text>
        </Box>
    );
};

export default wrapFunctionalComponent(ProductViewsCount, 'ProductViewsCount');
